
import nlMessages from '../locales/nl-NL';

const NlLang = {
    messages: {
        ...nlMessages
    },
    locale: 'nl-NL',
   
};
export default NlLang;